'use client';

import Breadcrumbs from '@components/BreadCrumbs';
import { usePathname } from 'next/navigation';
import { FC } from 'react';

interface BreadcrumbProps {
  shopname?: string;
  isShopPage?: boolean;
}

const LayoutBreadcrumbs: FC<BreadcrumbProps> = ({ shopname, isShopPage }) => {
  const pathname = usePathname();
  const asPath = pathname;
  const pathnames = asPath.split('/').filter((x) => x);
  const notInLayoutPaths = ['properties', 'our-listings'];
  const showBreadcrumbsInLayout = notInLayoutPaths.every(
    (s) => pathnames[pathnames.length - 1] !== s,
  );

  const marginMapping = {
    'development-services/listings/': '48px',
    'properties/our-listings/': '32px',
  };

  const getMarginBottom = (pathname) => {
    for (const [path, margin] of Object.entries(marginMapping)) {
      if (pathname.includes(path)) {
        return margin; // Return the correct margin if path in mapping
      }
    }
    return '0px'; // Default margin if no path in mapping
  };

  const marginBottom = getMarginBottom(pathname);

  if (showBreadcrumbsInLayout) {
    return <Breadcrumbs isShopPage={isShopPage} shopname={shopname} marginBottom={marginBottom} />;
  }
};

export default LayoutBreadcrumbs;
